"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sort = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
function Sort({ customSorters }) {
    const { t } = (0, app_1.useTranslation)();
    const { setQuery } = (0, app_1.useRouter)();
    const handleSubmit = (sort) => {
        if (sort) {
            const [by, order] = sort.split('-');
            void setQuery((q) => (Object.assign(Object.assign({}, q), { sort: by, sortOrder: order !== null && order !== void 0 ? order : 'asc' })));
        }
        return sort;
    };
    return ((0, jsx_runtime_1.jsxs)(ui_1.SelectInput, Object.assign({ name: "sort", placeholder: t('label.sortBy'), onChange: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: "title" }, { children: t('label.default') })), (0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: "createdAt" }, { children: t('info.recentlyAdded') })), customSorters === null || customSorters === void 0 ? void 0 : customSorters.map((sorter) => {
                const value = `${sorter.by}-${sorter.order}`;
                return ((0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: value }, { children: sorter.title }), value));
            })] })));
}
exports.Sort = Sort;
